module.exports = __webpack_public_path__ + "5796a36a64ac81966f4f01cfb6a34aa8.svg";